import.meta.glob([
    '../images/**',
    '../fonts/**',
]);

import { Livewire, Alpine } from '../../../../../../../../vendor/livewire/livewire/dist/livewire.esm';
import Clipboard from '@ryangjchandler/alpine-clipboard'

Alpine.plugin(Clipboard)
Livewire.start()

// Swiper
import {Swiper, Navigation, Pagination, Autoplay, Grid, Controller, Thumbs, EffectFlip} from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import 'swiper/css/grid';
import 'swiper/css/effect-flip';
window.Swiper = Swiper

// AOS
import 'aos/dist/aos.css';
import AOS from 'aos';
AOS.init()

// Lazyload
import lazySizes from 'lazysizes';

// fslightbox
import FsLightbox from "fslightbox";

// Fancybox
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

// Swal
import Swal from 'sweetalert2';
window.Swal = Swal;
window.Toast = Swal.mixin({
    toast: true,
    position: 'top-right',
    iconColor: 'white',
    customClass: {
        popup: 'colored-toast'
    },
    showConfirmButton: false,
    timer: 3330,
    timerProgressBar: true
});

// Plyr
import Plyr from 'plyr';
import 'plyr/src/sass/plyr.scss'

// Slides
const buildSwiperCustom = sliderElm => {
    const sliderIdentifier = sliderElm.dataset.id;

    var delay = typeof sliderElm.dataset.delay !== 'undefined' ? sliderElm.dataset.delay : 2500 ;

    var slides_xs_enabled = false;
    var slides_sm_enabled = false;
    var slides_md_enabled = false;
    var slides_lg_enabled = false;
    var slides_xl_enabled = false;

    var slides_xs = 3;
    var slides_sm = 3.5;
    var slides_md = 4;
    var slides_lg = 5;
    var slides_xl = 6;

    if( typeof sliderElm.dataset.xs !== 'undefined' ){
        slides_xs = sliderElm.dataset.xs;
        slides_xs_enabled = true;
    }
    if( typeof sliderElm.dataset.md !== 'undefined' ){
        slides_md = sliderElm.dataset.md;
        slides_md_enabled = true;
    }
    if( typeof sliderElm.dataset.sm !== 'undefined' ){
        slides_sm = sliderElm.dataset.sm;
        slides_sm_enabled = true;
    }
    if( typeof sliderElm.dataset.lg !== 'undefined' ){
        slides_lg = sliderElm.dataset.lg;
        slides_lg_enabled = true;
    }
    if( typeof sliderElm.dataset.xl !== 'undefined' ){
        slides_xl = sliderElm.dataset.xl;
        slides_xl_enabled = true;
    }

    var center_slides = typeof sliderElm.dataset.center_slides !== 'undefined' ? sliderElm.dataset.center_slides : false ;
    var center_slides_bounds = typeof sliderElm.dataset.center_slides_bounds !== 'undefined' ? sliderElm.dataset.center_slides_bounds : false ;
    var loop = typeof sliderElm.dataset.loop !== 'undefined' ? sliderElm.dataset.loop : false ;

    return new Swiper('[data-id="'+sliderIdentifier+'"]', {
        modules: [Navigation, Grid], //Autoplay
        direction:'horizontal',
        slidesPerView:slides_xs,
        spaceBetween:15,
        centeredSlides:center_slides,
        centeredSlidesBounds:center_slides_bounds,
        loop: loop,
        // autoplay: {
        //     delay: delay,
        //     disableOnInteraction: false,
        // },
        // navigation:true,
        // navigation: {
        //     nextEl: '.swiper-button-next-slide-' + sliderIdentifier,
        //     prevEl: '.swiper-button-prev-slide-' + sliderIdentifier,
        //     disabledClass:'!bg-gray-100 text-gray-200'
        // },
        breakpoints: {
            // xs
            520: {
                enabled:slides_xs_enabled,
                slidesPerView:slides_xs,
                spaceBetween:15,
            },
            // sm
            640:{
                enabled:slides_sm_enabled,
                slidesPerView:slides_sm,
                spaceBetween:15,
                loop: false,
            },
            // md
            768: {
                enabled:slides_md_enabled,
                slidesPerView:slides_md,
                spaceBetween:15,
            },
            // lg
            1024:{
                enabled:slides_lg_enabled,
                slidesPerView:slides_lg,
                spaceBetween:15,
            },
            // xl
            1280:{
                enabled:slides_xl_enabled,
                slidesPerView:slides_xl,
                spaceBetween:15,
            },
            // 2xl
            // 1536: {

            // },
        }
    });
}

const setupApp = ()=>
{
    lazySizes.init();

    refreshFsLightbox();

    // Fancybox
    Fancybox.bind("[data-fancybox]", {
        // Your custom options
    });

    const myVideoPlayer1 = new Plyr('#myVideoPlayer1', {
        ratio: '16:9',
    });

    const myVideoPlayer2 = new Plyr('#myVideoPlayer2', {
        ratio: '16:9',
    });

    const allSwipersCustom = document.querySelectorAll('.custom-swiper');
    allSwipersCustom.forEach(slider => buildSwiperCustom(slider));


    // let heroSwiper = new Swiper("#heroSwiper", {
    //     modules: [Controller, Pagination, Autoplay],
    //     slidesPerView: 1,
    //     spaceBetween: 10,
    //     // loop: true,
    //     autoplay: {
    //         delay: 5000,
    //         disableOnInteraction: true,
    //         pauseOnMouseEnter: true,
    //     },
    //     pagination: {
    //         el: "#heroSwiperPagination",
    //         clickable: true
    //     },
    // });

    let heroSwiper2 = new Swiper("#heroSwiper2", {
        modules: [Navigation, Autoplay, EffectFlip],
        slidesPerView: 1,
        effect: "flip",
        loop: true,
        autoplay: {
            delay: 3500,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
        },
        navigation: {
            nextEl: "#heroSwiperNext",
            prevEl: "#heroSwiperPrev",
        },
    });

    // heroSwiper.controller.control = heroSwiper2;
    // heroSwiper2.controller.control = heroSwiper;

    // var swiperAnimation = new SwiperAnimation();

    // const heroSwiper = new Swiper('.hero-swiper-container', {
    //     modules: [Autoplay],
    //     autoplay: {
    //         delay: 5000,
    //     },
    // });
    //
    // const heroImageSwiper = new Swiper('.hero-img-swiper', {
    //     modules: [Navigation, Pagination, Keyboard, EffectFade, Autoplay, Controller],
    //     slidesPerView: 1,
    //     autoplay: {
    //         delay: 8000,
    //     },
    //     // loop: true,
    //     effect: 'fade',
    //     fadeEffect: {
    //         crossFade: true
    //     },
    //     navigation: {
    //         prevEl: '.hero-swiper-button-next',
    //         nextEl: '.hero-swiper-button-prev',
    //         disabledClass: 'text-gray-200 scale-90 border-none transition-all duration-300 ease-in-out',
    //     },
    // });

    // const heroDescSwiper = new Swiper('.hero-desc-swiper', {
    //     modules: [EffectFade, Autoplay],
    //     // autoplay : true,
    //     slidesPerView: 1,
    //     effect: 'fade',
    //     // fade: { crossFade: true },
    //     // loop: true,
    //     // effect: 'fade',
    //     // fadeEffect: {
    //     //     crossFade: false
    //     // },
    //     allowTouchMove: false
    //     // navigation: {
    //     //     nextEl: '.hero-swiper-button-next',
    //     //     prevEl: '.hero-swiper-button-prev',
    //     //   },
    // });

    const varietySwiper = new Swiper('#variety-swiper', {
        slidesPerView: 1.2,
        centeredSlides:true,
        centeredSlidesBounds:true,
        direction:'horizontal',
        spaceBetween:15,
        autoplay : false,
        loop: true,
        breakpoints:{
            640:{
                slidesPerView:2,
            },
            1024:{
                slidesPerView:4,
                enabled:false,
                centeredSlides:false,
                centeredSlidesBounds:false,
            }

        }
    });

    const blogSwiper = new Swiper('#blog-swiper', {
        modules: [Pagination],
        slidesPerView: 1.3,
        direction:'horizontal',
        spaceBetween:15,
        // autoplay : true,
        // loop: true,
        breakpoints:{
            640:{
                slidesPerView:2,
            },
            1024:{
                slidesPerView:4,
                spaceBetween:30,
            }
        },
        pagination: {
            el: '#blog-swiper .swiper-pagination',
            type: 'bullets',
            clickable:true,
            bulletClass: 'swiper-pagination-bullet !w-4 !h-4',
            bulletActiveClass: 'swiper-pagination-bullet-active -translate-y-1 transition-all border border-topco-800',
        },
    });

    const bigFeaturesSwiper = new Swiper("#big-features", {
        modules:[Pagination],
        pagination: {
            el: '#big-features .swiper-pagination',
            type: 'bullets',
            clickable:true,
            bulletClass: 'swiper-pagination-bullet !w-4 !h-4',
            bulletActiveClass: 'swiper-pagination-bullet-active -translate-y-1 transition-all border border-topco-800',
        },
        slidesPerView: 1, // 1.1
        direction:'horizontal',
        spaceBetween:15,
        // autoplay : true,
        // loop: true,
        breakpoints:{
            // 640:{
            //   slidesPerView:1.,
            // },
            1024:{
                slidesPerView:1, // 1.1
                // spaceBetween:30,
                // enabled:false,
            }

        }
    });

    // heroImageSwiper.controller.control = heroDescSwiper;

    const productGalleryThumb = new Swiper('.product-thumb-imgs-swiper-container', {
        modules: [Navigation],
        direction: 'horizontal',
        spaceBetween: 10,
        slidesPerView: 3,
        breakpoints: {
            768:{
                slidesPerView: 4,
            },
        },
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
    });

    const productGallery = new Swiper('.product-imgs-swiper-container', {
        modules: [Navigation, Thumbs],
        direction: 'horizontal',
        centeredSlides:true,
        centeredSlidesBounds:true,
        slidesPerView:1,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        spaceBetween: 10,
        thumbs: {
            swiper : productGalleryThumb
        },
    });

    const portfolioGalleryThumb = new Swiper('.portfolio-thumb-imgs-swiper-container', {
        modules: [Navigation],
        direction: 'horizontal',
        spaceBetween: 10,
        slidesPerView: 5.5,
        centeredSlides:true,
        centeredSlidesBounds:true,
        freeMode: true,
        loop: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        breakpoints: {
            320: {
                slidesPerView: 3.5,
            },
            480: {
                slidesPerView: 3.5,
            },
            640: {
                slidesPerView: 4.5,
            },
            1280:{
                slidesPerView: 5.5,
            },
        }
        // thumbs: {
        //   swiper: productGalleryThumb
        // }
    });

    const portfolioGallery = new Swiper('.portfolio-imgs-swiper-container', {
        modules: [Navigation, Thumbs],
        direction: 'horizontal',
        centeredSlides:true,
        centeredSlidesBounds:true,
        slidesPerView:1,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        // clickable:"true",
        spaceBetween: 10,

        thumbs: {
            swiper : portfolioGalleryThumb
        },
    });

    const brandsSwiper = new Swiper('#brandsSwiper', {
        modules: [Navigation, Pagination],
        slidesPerView: 4,
        spaceBetween: 30,
        loop: true,
        breakpoints: {
            320: {
                slidesPerView: 2.3,
                centeredSlides: true,
                centeredSlidesBounds: true,
            },
            480: {
                slidesPerView: 3,
                centeredSlides: true,
                centeredSlidesBounds: true,
            },
            640: {
                slidesPerView: 4,
            }
        }
    });

    const landingFeaturesSwiper = new Swiper("#landingFeaturesSwiper", {
        modules: [Navigation],
        slidesPerView: 1.2,
        spaceBetween: 24,
        centeredSlides:true,
        loop:true,
        breakpoints: {
            480: {
                slidesPerView:1.2,
                spaceBetween: 20
            },
            768: {
                slidesPerView: 3.5,
                spaceBetween: 24
            },
            1024: {
                slidesPerView: 3.5,
                spaceBetween: 24,
                centeredSlides:false,
            },
            1280: {
                slidesPerView: 3.5,
                spaceBetween: 24,
                centeredSlides:false,
            },
        },
    });

    const projectsGallerySwiper = new Swiper("#projectsGallerySwiper", {
        modules: [Navigation],
        slidesPerView: 1.3,
        spaceBetween: 3,
        centeredSlides:true,
        centeredSlidesBounds:true,
        loop:true,
        breakpoints: {
            480: {
                slidesPerView: 2,
                spaceBetween: 20
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 24,
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 24,
            },
            1280: {
                slidesPerView: 3,
                spaceBetween: 24,
            },
        },
    });

    const productRelatedItems = new Swiper('.product-related-items',  {
        slidesPerView: 1.2,
        spaceBetween: 15,
        breakpoints:{
            768:{
                slidesPerView: 2.3,
            },
            1024: {
                slidesPerView:3.3,
            },
            1280:{
                slidesPerView:4.3,
            },
        }
    });



    const logo = document.querySelector('#logo');
    const headerel = document.querySelector('#headerel');
    const headerFirstLevel = document.querySelector('#header-first-level');
    const discountBarel = document.querySelector("#discount-bar");
    const scrollThreshold = 100; // Change this to the number of pixels you want to scroll before changing the height
    let prevScrollPosition = window.scrollY;

    window.addEventListener('scroll', () => {
        const scrollPosition = window.scrollY;

        if( screen.width < 768 ){
            if (scrollPosition > scrollThreshold && scrollPosition > prevScrollPosition) {
                // User has scrolled past the threshold and is scrolling down, update the height of the logo
                logo.classList.remove('lg:h-[3.5rem]'); // Change this to the new height of the logo
                // get the height of headerFirstLevel and translate the headerel to the top in the amount of headerfirstlevel height
                const headerFirstLevelHeight = headerFirstLevel.offsetHeight;
                const discountBarHeight = discountBarel.offsetHeight;
                // console.log(`The height is ${headerFirstLevelHeight}`)
                headerel.style.transform = `translateY(-${headerFirstLevelHeight+discountBarHeight}px)`;
            } else {
                // User has not scrolled past the threshold or is scrolling up, reset the height of the logo
                logo.classList.add('lg:h-[3.5rem]'); // Change this to the original height of the logo
                headerel.style.transition = 'transform 0.3s ease-in-out';
                headerel.style.transform = 'translateY(0)';
            }

            prevScrollPosition = scrollPosition;
        }
    });

};

window.setupApp = setupApp;

["livewire:initialized", "livewire:navigated", "resize", "pageChanged"].forEach((event) => {
    window.addEventListener(event, setupApp)
})

// window.addEventListener("livewire:navigated", function(){
//     window.scrollTo({top: 0, behavior: 'smooth'});
// })
